import { Fragment, useState, useEffect, useLayoutEffect } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { MOVE_FILE, MOVE_FOLDER } from "../../utils/constants";
import { hideMessage } from "../../utils/customer/artifactSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import { useFetchCustomerDocumentDataQuery } from "../../utils/customer/customerTaskTable";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";
import { ReactComponent as FolderIcon } from "../../assets/images/icons/FolderIcon.svg";
import { ReactComponent as UserEdit } from "../../assets/images/user-edit.svg";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { pushAlert } from "../../utils/alertSlice";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
// import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DocumentIcon from "../../utils/utilityFunctions/iconUtility";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import { ReactComponent as NoFolderIcon } from "../../assets/images/NoFolderIcon.svg";
import AddIcon from "@mui/icons-material/Add";
import ReplyIcon from "@mui/icons-material/Reply";
import { ReactComponent as MySpaceNoData } from "../../assets/images/icons/MySpaceNoData.svg";
import {
  mySpaceAddList,
  mySpaceCreateFolder,
  mySpaceFileFolderDelete,
  mySpaceGetFolder,
  mySpaceMarkAsPin,
  mySpaceMarkAsUnpin,
  mySpaceRenameAndMoveFolderFile,
  mySpaceTableSharedFileFolder,
} from "../../utils/api/mySpaceApi";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import Breadcrumb from "../UniversalComponents/Breadcrumb";
import NewToggleSwitch from "../UniversalComponents/NewToggleSwitch";
import FileExplorer from "../UniversalComponents/FileExplorer";
import MoveDocumentModal from "../customer/Documents/MoveDocumentModal";
import OverviewDialog from "./OverviewDialog";
import RequestAccessDialog from "./RequestAccessDialog";
import ApproverDialogue from "./ApproverDialogue";
import CustomerEditTaskActivity from "./CustomerEditTaskActivity";
import CreateListDrawer from "./CreateListDrawer";
import ShareFileModal from "./ShareFileModal";
import { ReactComponent as RoundedFilledPlusIcon } from "../../assets/images/roundedFilledPlusIcon.svg";
import { ReactComponent as UploadFileIcon } from "../../assets/images/uploadFileIcon.svg";
import FileUploadModal from "./FileUploadModal";
import { ReactComponent as PencilIcon } from "../../assets/images/pencilIcon.svg";
import RenameFolderFileModal from "./RenameFolderFileModal";
import FolderAction from "./FolderAction";
import AddFolderModal from "./AddFolderModal";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import DeleteIcon from "@mui/icons-material/Delete";
import Dropdown from "./MenuOptionsToCreate";
import { MenuIcon } from "lucide-react";
import MenuOptionsDropdown from "./MenuOptionsToCreate";
import { CloudDownload } from "@mui/icons-material";
import { ReactComponent as CreateList } from "../../assets/images/CreateList.svg";
import { ReactComponent as NewFolderIcon } from "../../assets/images/FolderIcon.svg";
import { ReactComponent as NewFilesUpload } from "../../assets/images/fileUpload.svg";
import SharedPerson from "./SharedPerson";
import SharedPersonDrawer from "./SharedPerson";
import { ReactComponent as BackIcon } from "../../assets/images/back_arrow_black.svg";
import { ReactComponent as ShareWithImg } from "../../assets/images/icons/ShareWithImg.svg";
import ShareWithIcon from "../../assets/images/icons/shareWIthIcon";
import LoginIcon from "@mui/icons-material/Login";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";
import { useSidebar } from "../SidebarContext";
import { getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import MySpacePinnedDrawer from "./MySpacePinnedDrawer";
import { ReactComponent as GreenPin } from "../../assets/images/green_pin.svg";
import { ReactComponent as MySpaceSvg } from "../../assets/images/my-space.svg";
// /src/assets/images/backIconAddCustomer.svg

const MySpaceDocument = ({
  setShowListView,
  setContainerId,
  setSelectedRecord,
  initialbreadcrumpList = [{ label: "Root", isContainer: true }],
  setShowCsvUploadPreview,
  csvFileData,
  setCsvFileData,
  mySpaceDocumentList,
  setMySpaceDocumentList,
  showListView,
  queryContainerId,
  containerId,
  isShared,
  type,
}) => {
  const user = useRequireAuth();
  const { id: customerId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const message = useSelector((state) => state.customerArtifact.message);
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = companyLocalData ? JSON.parse(companyLocalData) : null;
  const showMessage = useSelector((state) => state.customerArtifact.showMessage);
  const [isHovered, setIsHovered] = useState(false);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [createMenuModal, setCreateMenuModal] = useState(null);
  const [showAddFolderModal, setShowAddFolderModal] = useState(false);
  const [folderName, setFolderName] = useState("");
  const colorOptions = ["#FACD26", "#DE3B20", "#E57000", "#4D9F45", "#3C938E", "#3785D3", "#9761CA", "#C553B6"];
  const [folderColor, setFolderColor] = useState("#FACD26"); // Default color
  // const [folderId, setFolderID] = useState(queryContainerId);
  const [isMySpacePinnedDrawerOpen, setIsMySpacePinnedDrawerOpen] = useState(false);

  const [dataMove, setDataMove] = useState({});
  const [showShareDialog, setShareDialog] = useState(null);
  const [showAIPreviewModal, setShowAIPreviewModal] = useState(false);
  const [openMoveDialog, setOpenMoveDialog] = useState(false);
  const [requestDocumentAccessModal, setRequestDocumentAccessModal] = useState(false);
  const [openApproverDialog, setOpenApproverDialog] = useState(false);
  const [openActivityDialog, setOpenActivityDialog] = useState(false);
  const [isShowCreateList, setIsShowCreateList] = useState(false);
  const [activityId, setActivityId] = useState("");

  const [breadcrumpList, setBreadcrumpList] = useState(initialbreadcrumpList);
  const [showPasteButton, setShowPasteButton] = useState(false);

  const [isListView, setIsListView] = useState(true);
  const [isRenameFolderFileModalOpen, setIsRenameFolderFileModalOpen] = useState(false);
  const [isDeleteFolderFileModalOpen, setIsDeleteFolderFileModalOpen] = useState(false);
  const [resetTableIndex, setResetPageIndex] = useState(false);

  const [isApiLoading, setIsApiLoading] = useState(false);
  const [isAssetShareDrawerOpen, setIsAssetShareDrawerOpen] = useState(false);
  const [showSharedFileFolder, setShowSharedFileFolder] = useState(isShared);
  const [sharedFileFolderData, setSharedFileFolderData] = useState([]);
  const [isFirstRender, setIsFirstRender] = useState(true);

  //-------------------

  // const [mySpaceDocumentList, setMySpaceDocumentList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  // ----------------------

  //For setting data in Header
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  function MySpaceHeaderUI() {
    return <NewToggleSwitch onToggle={handleToggle} toggleState={isListView} className={"w-30 h-8"} />;
  }

  useEffect(() => {
    // if (!showListView) {
    //   setheaderProps({ name: "VADS Consulting Pvt. Ltd.", ActionTab: MySpaceHeaderUI });
    // } else {
    setheaderProps({ name: "My Space" });
    // }
    document.title = "Zinancial | My Space";
    return () => {
      setheaderProps(null);
      document.title = "Zinancial";
    };
  }, [setheaderProps, showListView]);

  // const {
  //   data: customerDocumentData,
  //   refetch: refetchCustomerData,
  //   isLoading,
  // } = useFetchCustomerDocumentDataQuery({
  //   customerId: customerId,
  //   folderId: folderId ? folderId : "",
  //   userId: user.user_id,
  //   orgId: user.org_id,
  //   companyId: parsedCompanyData.company_id,
  //   token: user?.token,
  // });
  // API - FETCH ALL CONTAINERS
  const handleGetContainerList = async ({ containerId = null }) => {
    try {
      setIsFirstRender(false);
      setIsApiLoading(true);
      const query = {};
      if (containerId) {
        query.folderId = containerId;
      }

      let response;
      if (showSharedFileFolder) {
        response = await mySpaceTableSharedFileFolder({ query });
      } else {
        response = await mySpaceGetFolder({ query });
      }

      if (response?.success) {
        // Converting to standard format.
        const data = response?.data?.map((item) => {
          return {
            id: item?.id,
            display_name: item?.name,
            type: item?.type,
            modified: item?.modified,
            created_by: item?.created_by,
            file_size: item?.file_size,
            sharing: item?.sharing,
            activity: item?.activity,
            ...item,
          };
        });

        const breadcrumpList = response?.path?.map((data) => {
          // Only root folder will be considered as container. so is Null
          return {
            label: data?.folderName,
            id: data?.folderId,
            isContainer: data?.folderId ? true : false,
          };
        });

        setBreadcrumpList(breadcrumpList);

        if (showSharedFileFolder) {
          setSharedFileFolderData(data);
        } else {
          setMySpaceDocumentList(data);
        }

        setResetPageIndex(false);
        // dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message || "Something went wrong", visible: true }));
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleCreateList = async (listName, description) => {
    try {
      const body = {
        name: listName,
        description: description,
      };

      const folderId = breadcrumpList[breadcrumpList.length - 1]?.id;

      if (folderId) {
        body.parent_id = folderId;
      }

      const response = await mySpaceAddList({ body });
      if (!response?.data?.success) {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
        await handleGetContainerList({ containerId: folderId });
      }

      dispatch(
        pushAlert({ type: "success", message: response?.data?.message || "List created successfully", visible: true })
      );
      setIsShowCreateList(false);
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message || "Something went wrong", visible: true }));
    }
  };

  // useEffect(() => {
  //   if (initialbreadcrumpList.length > 1) {
  //     setFolderID(initialbreadcrumpList[initialbreadcrumpList.length - 1].id);
  //   }
  // }, [initialbreadcrumpList]);

  function handleToggle() {
    setIsListView((prev) => !prev);
    localStorage.setItem("isListView", JSON.stringify(!isListView));
  }

  const handleMove = (item, action) => {
    setDataMove({ action: action, dirPath: breadcrumpList[breadcrumpList.length - 1], ...item });
    setOpenMoveDialog(true);
  };

  /* NOTE: handlePaste function agrument consist "dragToItem" which is the item where we need to paste the data.
    1. handlePaste argument(dragToItem) should be empty if not using drag/drop option.
    2. "dataMove" consist the data which we need to move.
    3. "breadcrumpList" consist the data where we need to paste the data.
    4. "dataMove" and "dragToItem" should not be same. */
  const handlePaste = (dragToItem) => {
    let item = {};
    // This is used when we move/copy and paste the file/folder from contextMenu.
    if (dragToItem?.type) {
      // Simply check the dragable item should be draged in itself (DragtoItem and dataMove should not be same.)
      if (dragToItem?.id !== dataMove?.id) {
        item = dragToItem;
      } else {
        dispatch(pushAlert({ type: "danger", message: "You can't move to the same folder", visible: true }));
        return;
      }
    } else {
      if (dataMove?.id === breadcrumpList[breadcrumpList.length - 1]?.id) {
        dispatch(pushAlert({ type: "danger", message: "You can't move to the same folder", visible: true }));
        return;
      } else if (dataMove?.dirPath?.label !== breadcrumpList[breadcrumpList.length - 1]?.label) {
        // Collecting breadcrump data to define where to put data and "dataMove" consist what data needed to move.
        item = breadcrumpList[breadcrumpList.length - 1];
      } else {
        dispatch(pushAlert({ type: "danger", message: "You can't move to the same folder", visible: true }));
        return;
      }
    }
    // if (dataMove?.type === "folder") handleMoveFolder(item);
    // else handleMoveFile(item);

    handleMoveFolder(item);
  };

  const handleShare = (item) => {
    setShareDialog(item);
  };
  const handleOverview = (item) => {
    setShowAIPreviewModal(true);
  };

  const handlePinFileFolder = async (item) => {
    try {
      const response = await mySpaceMarkAsPin({ body: { containerId: item?.id } });
      if (response?.success) {
        const folderId = breadcrumpList[breadcrumpList.length - 1]?.id;
        dispatch(pushAlert({ type: "success", message: response?.message || "Pinned successfully", visible: true }));
        handleGetContainerList({ containerId: folderId });
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleUnPinFileFolder = async (item) => {
    try {
      const response = await mySpaceMarkAsUnpin({ body: { containerId: item?.id } });
      if (response?.success) {
        const folderId = breadcrumpList[breadcrumpList.length - 1]?.id;
        dispatch(pushAlert({ type: "success", message: response?.message || "Pinned successfully", visible: true }));
        handleGetContainerList({ containerId: folderId });
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleRequestAccess = (item, action) => {
    setRequestDocumentAccessModal(true);
  };

  const handleMoveFolder = async (data) => {
    const folderData = {
      userId: user.user_id,
    };

    if (dataMove.action === "move") {
      if (data.isContainer) folderData.containerId = data.id;
      else folderData.parentId = data.id;
    } else folderData.targetparentId = data.id;

    try {
      // const response = await fetch(`${MOVE_FOLDER}${dataMove.id}/${dataMove.action}`, {
      //   method: "Post",
      //   headers: {
      //     Authorization: `Bearer ${user?.token}`,
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(folderData),
      // });

      const response = await mySpaceRenameAndMoveFolderFile({
        body: { parent_id: data?.id || null },
        params: { "folder-file-id": dataMove.id },
      });

      if (response.success) {
        // Handle success, maybe close the dialog or show a success message
        // handleDialogClose();
        setOpenMoveDialog(false);
        // await fetchData(customerId);
        dispatch(
          pushAlert({ type: "success", message: response?.message || "Folder moved successfully", visible: true })
        );
        setDataMove({});
        handleGetContainerList({ containerId: data?.id || null });
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
        console.error("Error creating folder:", response.statusText);
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message || "Something went wrong", visible: true }));
      console.error("Network error:", error);
    }
  };

  const handleMoveFile = async (data) => {
    const fileData = {
      userId: user.user_id,
      targetId: data.id,
      isContainer: data.isContainer,
    };

    try {
      const response = await fetch(`${MOVE_FILE}${dataMove.id}/${dataMove.action}`, {
        method: "Post",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fileData),
      });

      if (response.ok) {
        setOpenMoveDialog(false);
        dispatch(
          pushAlert({ type: "success", message: response?.message || "File moved successfully", visible: true })
        );
        setDataMove({});
        // refetchCustomerData();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
        console.error("Error creating folder:", response.statusText);
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message || "Something went wrong", visible: true }));
      console.error("Network error:", error);
    }
  };

  //-------------------------------------- TO OPEN LIST VIEW -------------------------------------
  const handleOpenTable = (folder) => {
    // To pass the container id in the API
    setContainerId(folder?.id);

    // To set the selected record in the table
    setSelectedRecord(folder?.display_name);

    // To show the list view
    setShowListView(true);
  };

  const handleOpenFolder = (folder) => {
    // setBreadcrumpList((prev) => [...prev, { label: folder?.display_name, isContainer: false, id: folder?.id }]);

    // setFolderID(folder?.id);
    handleGetContainerList({ containerId: folder?.id });
  };

  const handleDirectory = (val) => {
    if (val.isContainer) {
      // setFolderID(null);
    } else {
      const newArr = breadcrumpList;

      // setFolderID(val.id);
      setBreadcrumpList(newArr.slice(0, newArr.findIndex((item) => val.id === item.id) + 1));
    }
  };

  const handleRowClick = (data) => {
    if (!isApiLoading) {
      try {
        // let selectedData;
        if (data?.type === "folder") {
          // For share file folder, we need to check if the data is from shared file folder or my space document list
          // if (showSharedFileFolder) {
          // const getSelectedDataIndex = sharedFileFolderData?.findIndex((option) => {
          //   return data?.id === option?.id;
          // });
          // selectedData = sharedFileFolderData[getSelectedDataIndex];
          // } else {
          // const getSelectedDataIndex = mySpaceDocumentList?.findIndex((option) => {
          //   return data?.id === option?.id;
          // });
          // selectedData = mySpaceDocumentList[getSelectedDataIndex];
          // }

          handleGetContainerList({ containerId: data?.id });
          // setFolderID(data?.id);
          // setBreadcrumpList((prev) => {
          //   return [...prev, { label: selectedData?.display_name, isContainer: false, ...selectedData }];
          // });
          setResetPageIndex(true);
          if (showSharedFileFolder) {
            navigate(`/my_space/shared/folders/${data?.id}`, { replace: false });
          } else {
            navigate(`/my_space/folders/${data?.id}`, { replace: false });
          }
        } else {
          if (data?.type?.toLowerCase() === "table") {
            handleOpenTable(data);
            if (showSharedFileFolder) {
              navigate(`/my_space/shared/tables/${data?.id}`, { replace: false }); // false = push to history
            } else {
              navigate(`/my_space/tables/${data?.id}`, { replace: false }); // false = push to history
            }
          }
        }
      } catch (error) {
        dispatch(
          pushAlert({
            visible: true,
            message: error?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    }
  };

  const handleBreadcrumpDataClicked = (data) => {
    // if (data?.id) {
    //   if (data.isContainer) {
    //     setFolderID(null);
    //   }
    //   else {
    //     setFolderID(data?.id);
    //   }
    // }
    handleGetContainerList({ containerId: data?.id });
    let newUrl;
    // Navigate update on URL
    if (data?.id) {
      if (isShared) {
        newUrl = `/my_space/shared/folders/${data?.id}`;
      } else {
        newUrl = `/my_space/folders/${data?.id}`;
      }
    } else {
      if (isShared) {
        newUrl = `/my_space/shared/folders`;
      } else {
        newUrl = `/my_space/folders`;
      }
    }
    navigate(newUrl, { replace: false });

    // Assuming to be the initial option for breadcrump
    // Hence, resetting for initial state
    // else {
    //   setFolderID();
    //   if (showSharedFileFolder) {
    //     setBreadcrumpList([{ label: "Shared With Me", isContainer: true }]);
    //   } else {
    //     // setBreadcrumpList([{ label: "My Space", isContainer: true }]);
    //   }
    // }
  };

  const handleDirectoryBack = () => {
    // const newArr = breadcrumpList.slice(0, breadcrumpList.length - 1);
    // if (newArr.length > 1) setFolderID(newArr[newArr.length - 1].id);
    // else setFolderID(null);
    // setBreadcrumpList(newArr);
    handleGetContainerList({ containerId: breadcrumpList[breadcrumpList.length - 2]?.id });
  };

  // SHARED FILE FOLDER GET API
  const handleSharedFileFolder = async () => {
    try {
      const response = await mySpaceTableSharedFileFolder({ query: {} });
      if (response?.success) {
        setSharedFileFolderData(response?.data);
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message || "Something went wrong", visible: true }));
    }
  };

  useEffect(() => {
    if (showMessage === true) {
      dispatch(
        pushAlert({
          visible: true,
          message: message || "Operation successful",
          type: "success",
        })
      );
      // refetchCustomerData();
    }
  }, []);

  const openPopup = () => {
    setShowFileUploadModal(true);
    handleMenuClose();
  };

  const closePopup = () => {
    setShowFileUploadModal(false);
  };

  // const handleMenuOpen = (event) => {
  //   console.log("menu clicked");
  //   setAnchorEl(event.currentTarget);
  // };
  const handleMenuClose = () => setAnchorEl(null);

  const openFolderDialog = () => {
    setShowAddFolderModal(true);
    handleMenuClose();
  };

  const handleActivityDialog = (item) => {
    setActivityId(item?.autoId);
    setOpenActivityDialog(true);
  };

  const handleDialogClose = () => setShowAddFolderModal(false);
  const handleFolderNameChange = (event) => {
    setFolderName(event.target.value);
  };
  const handleColorSelect = (color) => setFolderColor(color);

  const handleSubmit = async () => {
    let body = { name: folderName, color: folderColor };

    const folderId = breadcrumpList[breadcrumpList.length - 1]?.id;

    if (folderId) {
      body.parent_id = folderId;
    }

    try {
      const response = await mySpaceCreateFolder({ body });

      if (response?.success) {
        handleDialogClose();
        handleGetContainerList({ containerId: folderId });
        dispatch(
          pushAlert({ type: "success", message: response?.success || "Folder created successfully", visible: true })
        );
        setFolderName("");
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleNewFolderOptionClick = () => {
    setShowAddFolderModal(true);
    handleMenuClose();
  };

  const handleNewFileOptionClick = () => {
    setShowFileUploadModal(true);
    handleMenuClose();
  };

  const handleShareOptionClick = (fileFolderData) => {
    setShareDialog(fileFolderData);
  };

  const handleCreateListClick = () => {
    setIsShowCreateList(true);
  };

  const handleRenameClick = (folderData) => {
    setIsRenameFolderFileModalOpen(folderData);
  };

  const handleDeleteClick = (folderData) => {
    setIsDeleteFolderFileModalOpen(folderData);
  };

  const handleMoveOptionClick = (rowData) => {
    setShowPasteButton(false);
    setDataMove({ action: "move", dirPath: breadcrumpList[breadcrumpList.length - 1], ...rowData });
    if (isListView) {
      setOpenMoveDialog(true);
    }
  };

  const handleCopyOptionClick = (rowData) => {
    if (dataMove.type === "folder") handleMoveFolder(rowData);
    else handleMoveFile(rowData);
  };

  function capitalizeFirstLetter(str) {
    if (!str) return ""; // Handle empty or undefined input
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleDeleteModal = (item) => {
    setIsDeleteFolderFileModalOpen(item);
  };

  const handleView = (item) => {
    try {
      const url = item?.file_url;
      if (!url) throw new Error("No file URL provided");

      // Open the URL in a new tab
      window.open(url, "_blank");
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
    }
  };

  async function handleDownload(item) {
    const url = item?.file_url;
    const link = document.createElement("a");
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleDeleteFileFolder = async () => {
    try {
      const response = await mySpaceFileFolderDelete({
        params: { "folder-file-id": isDeleteFolderFileModalOpen?.id },
      });

      if (response.success) {
        dispatch(
          pushAlert({ type: "success", message: response?.message || "Folder deleted successfully", visible: true })
        );
        handleGetContainerList({ containerId: isDeleteFolderFileModalOpen?.parent_id });
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message || "Something went wrong", visible: true }));
    } finally {
      setIsDeleteFolderFileModalOpen(false);
    }
  };

  const handleEdit = (item) => {
    setIsRenameFolderFileModalOpen(item);
  };

  const handleManageAccess = (item) => {
    setIsAssetShareDrawerOpen(item);
  };

  const HEADER_DEFINITION = [
    {
      accessor_key: "display_name",
      label: "Name",
      selfContent: (data, headerKey) => (
        <div
          className={`flex flex-row justify-between gap-2 ${data?.type !== "folder" && data?.type?.toLowerCase() !== "table" && "cursor-default"}`}
        >
          <span className="flex flex-row gap-2 items-center">
            {data.type === "folder" ? (
              <DocumentIcon
                type="folder"
                className="cursor-pointer"
                fill={data?.code}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenFolder(data);
                }}
              />
            ) : (
              <DocumentIcon type={data.type} filename={data.mimetype} />
            )}

            <span
              className={`${data?.type !== "folder" && data?.type?.toLowerCase() !== "table" && "cursor-context-menu"}`}
            >
              <span onClick={() => handleRowClick(data)}>
                {data?.display_name?.substring(0, 20) ?? data?.name?.substring(0, 20)}
                {data.type !== "folder" && data?.type !== "table" && "."}
                {data.mimetype}
              </span>
            </span>
          </span>

          <div
            onClick={(e) => {
              e.stopPropagation();
              setIsMySpacePinnedDrawerOpen(true);
            }}
            className="flex gap-2 items-center"
          >
            {data?.is_pinned ? <GreenPin /> : null}
            <FolderAction
              Item={data}
              handleMove={handleMove}
              handlePaste={handlePaste}
              showButtons={true}
              handleShare={handleShare}
              handleOverview={handleOverview}
              handleRequestAccess={handleRequestAccess}
              handleDelete={handleDeleteModal}
              handleEdit={handleEdit}
              handleView={handleView}
              handleDownload={handleDownload}
              handleManageAccess={handleManageAccess}
              handlePin={handlePinFileFolder}
              handleUnPin={handleUnPinFileFolder}
              showSharedFileFolder={showSharedFileFolder}
              accessType={data?.access}
            />
          </div>
        </div>
      ),
    },
    {
      accessor_key: "type",
      label: "Type",
      selfContent: (data) => capitalizeFirstLetter(data?.type?.toLowerCase() === "table" ? "List" : data?.type),
    },
    {
      accessor_key: "created_by",
      label: "Created By",
      type: "person",
      selfContent: (data) => (
        <span className="flex items-center gap-2 text-gray-800">
          <UserEdit className="text-gray-800" />
          {getTitleCase(data?.created_by)}
        </span>
      ),
    },
    {
      accessor_key: "modified",
      label: "Created At",
      selfContent: (data) => <span>{getUserDateTime(data?.created_at)}</span>,
    },
  ];

  const NO_DATA_FOUND_TABLE_JSX = (
    <div className="flex justify-center items-center flex-col space-y-2 group">
      {/* <NoFolderIcon /> */}
      <MySpaceNoData />
      <span className="text-14 text-black text-sm font-400">No Data Available.</span>
      {!showSharedFileFolder && (
        <MenuOptionsDropdown
          buttonIcon={
            <span
              // onClick={handleMenuOpen}
              className="border px-5 py-1.5 items-center text-center text-sm font-400  hover:border-[#1D4469] cursor-pointer hover:text-[#1D4469] text-[#383838] rounded-3xl shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
            >
              + Upload
            </span>
          }
          menuItems={[
            {
              label: "Add Folder",
              icon: "",
              onClick: () => {
                handleNewFolderOptionClick();
              },
            },
            {
              label: "Upload File",
              icon: "",
              onClick: () => {
                handleNewFileOptionClick();
              },
            },
            {
              label: "Create List",
              icon: "",
              onClick: () => {
                handleCreateListClick();
              },
            },
          ]}
          onOpen={() => console.log("Dropdown Opened")}
          onClose={() => console.log("Dropdown Closed")}
        />
      )}
    </div>
  );

  const DOCUEMNT_CONTEXT_MENU = [
    {
      label: "Rename",
      icon: <DriveFileRenameOutlineIcon />,
      onClick: (folderData) => handleRenameClick(folderData),
    },
    {
      label: "Move",
      icon: <DriveFileMoveIcon />,
      onClick: (rowData) => handleMoveOptionClick(rowData),
    },
    // {
    //   label: "Copy",
    //   icon: <ContentCopyIcon />,
    //   onClick: (rowData) => handleCopyOptionClick(rowData),
    // },
    // {
    //   label: "Paste",
    //   icon: <ContentPasteGoIcon />,
    //   onClick: () => handlePaste(),
    // },
    {
      label: "Download",
      icon: <CloudDownload />,
      onClick: (rowData) => handleDownload(rowData),
    },
    {
      label: "Share",
      icon: <ShareIcon />,
      onClick: (rowData) => {
        handleShareOptionClick(rowData);
      },
    },
    {
      label: "Manage Access",
      icon: <ShareIcon />,
      onClick: (rowData) => {
        handleManageAccess(rowData);
      },
    },
    {
      label: "Delete",
      icon: <DeleteIcon />,
      onClick: (folderData) => handleDeleteClick(folderData),
    },
  ];

  const OUTER_DOCUEMNT_CONTEXT_MENU = [
    {
      label: "New Folder",
      icon: <CreateNewFolderIcon />,
      onClick: () => handleNewFolderOptionClick(),
    },
    {
      label: "Create List",
      icon: <TableChartIcon />,
      onClick: () => handleCreateListClick(),
    },
    {
      label: "Upload File",
      icon: <InsertDriveFileIcon />,
      onClick: () => handleNewFileOptionClick(),
    },
    {
      label: "Paste",
      icon: <ContentPasteGoIcon />,
      onClick: () => handlePaste(),
    },
  ];

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(hideMessage());
    }, 3000);

    return () => clearTimeout(timeoutId); // Cleanup timeout on component unmount
  }, [dispatch]);

  // It is to update the Currect Directory ID in the root.
  // useEffect(() => {
  //   setContainerId(folderId);
  // }, [folderId, containerId]);

  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (!isFirstRender) {
      handleGetContainerList({ containerId: null });
    } else {
      handleGetContainerList({ containerId: containerId });
    }

    // Update view mode
    const isListView = localStorage.getItem("isListView");
    if (isListView) setIsListView(JSON.parse(isListView));
  }, [showSharedFileFolder]);

  useEffect(() => {
    if (type === "folders") {
      handleGetContainerList({ containerId: containerId });
    }
  }, [containerId]);

  if (showListView) return null;

  return (
    <div
      onContextMenu={(e) => e.preventDefault()}
      className={`h-full`}
      style={{ display: showListView ? "none" : "block" }}
    >
      <p className=" py-4 rounded-lg">
        {/* <span className="font-semibold text-gray-700 text-lg">My Space</span> */}
        {/* <br /> */}
        <span className="text-md text-gray-500 italic">
          Personalized workspace where you can store documents, organize files, and securely share them with others.
          Create, manage, and export lists of records with flexible tools for collaboration and data handling.
        </span>
      </p>
      {/* {showSharedFileFolder && (
        <button
          onClick={() => {
            setShowSharedFileFolder(false);
            navigate(`/my_space/folders`);
            // handleGetContainerList({ containerId: null });
          }}
          className="px-2 pt-3 flex gap-2 items-center"
        >
          <span>
            <BackIcon />
          </span>
          Back
        </button>
      )} */}
      {isListView ? (
        <ReactTableComponent
          tablename={
            breadcrumpList?.length > 1 && (
              <div className="w-fit p-1">
                <Breadcrumb
                  breadcrumpList={breadcrumpList}
                  setBreadcrumpList={setBreadcrumpList}
                  handleClick={handleBreadcrumpDataClicked}
                  maxBreadcrumpsLength={10}
                />
              </div>
            )
          }
          headers={HEADER_DEFINITION}
          body={showSharedFileFolder ? sharedFileFolderData : mySpaceDocumentList || []}
          onRowClick={(data) => {
            handleRowClick(data);
          }}
          isShowEmptyHeader={true}
          actionField={
            <Fragment>
              {!showSharedFileFolder && (
                <ToolTipComponent text="Add">
                  {/* <button onClick={handleMenuOpen} type="button" className="text-2541558A hover:text-254155"> */}
                  <MenuOptionsDropdown
                    buttonIcon={
                      <button className="border-[1px] border-[var(--color-primary)] rounded-full group hover:bg-[var(--color-primary)]">
                        <AddIcon className="text-primary group-hover:text-white" />
                      </button>
                    }
                    menuItems={[
                      {
                        label: "Add Folder",
                        icon: <NewFolderIcon className=" w-4 h-4" />,
                        onClick: () => {
                          handleNewFolderOptionClick();
                        },
                      },
                      {
                        label: "Upload File",
                        icon: <NewFilesUpload className="w-4 h-4" />,
                        onClick: () => {
                          handleNewFileOptionClick();
                        },
                      },
                      {
                        label: "Create List",
                        icon: <CreateList className="w-4 h-4" />,
                        onClick: () => {
                          handleCreateListClick();
                        },
                      },
                    ]}
                    onOpen={() => console.log("Dropdown Opened")}
                    onClose={() => console.log("Dropdown Closed")}
                  />
                  {/* </button> */}
                </ToolTipComponent>
              )}

              <ToolTipComponent text={showSharedFileFolder ? "My Space" : "Shared With Me"}>
                <button
                  onClick={() => {
                    setShowSharedFileFolder(!showSharedFileFolder);
                    navigate(showSharedFileFolder ? "/my_space/folders" : "/my_space/shared/folders");
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  className="group flex items-center gap-2 text-primary-80 hover:text-primary px-2 py-1 rounded-[5px] whitespace-nowrap text-sm"
                >
                  {showSharedFileFolder ? (
                    <span className="text-primary">
                      <MySpaceSvg className="hover:fill-current fill-gray-400" />
                    </span>
                  ) : (
                    <ReplyIcon className="group-hover:text-primary text-gray-400" />
                  )}
                </button>
              </ToolTipComponent>

              {/* <NewToggleSwitch onToggle={handleToggle} toggleState={isListView} className={"w-30 h-8"} /> */}
              {/* {!showSharedFileFolder && ( */}
              {/* )} */}
              {/* <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} sx={{ mr: 1 }}>
                <MenuItem onClick={openFolderDialog} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
                  <ListItemIcon>
                    <FolderIcon fontSize="small" className="text-ffe851" />
                  </ListItemIcon>
                  Add Folder
                </MenuItem>
                <MenuItem onClick={openPopup} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
                  <ListItemIcon>
                    <UploadFileIcon />
                  </ListItemIcon>
                  File Upload
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setIsShowCreateList(true);
                    handleMenuClose();
                  }}
                  sx={{ fontSize: "0.75rem", color: "#2c495d" }}
                >
                  <ListItemIcon className="m-0">
                    <RoundedFilledPlusIcon />
                  </ListItemIcon>
                  Create File
                </MenuItem>
              </Menu> */}
            </Fragment>
          }
          // actionColumn={(item) => {
          //   return (
          //     <div className="flex gap-6">
          //       <button
          //         onClick={(e) => {
          //           e.stopPropagation();
          //           setIsRenameFolderFileModalOpen(item);
          //         }}
          //       >
          //         <PencilIcon />
          //       </button>
          //       <button
          //         onClick={(e) => {
          //           e.stopPropagation();
          //           setIsDeleteFolderFileModalOpen(item);
          //         }}
          //       >
          //         <DeleteIcon color={"red"} size={18} />
          //       </button>
          //     </div>
          //   );
          // }}
          noDataFound={NO_DATA_FOUND_TABLE_JSX}
          resetPageIndex={false}
          resetTableIndex={resetTableIndex}
          isMySpace={true}
        />
      ) : (
        <FileExplorer
          tablename={
            <Breadcrumb
              breadcrumpList={breadcrumpList}
              setBreadcrumpList={setBreadcrumpList}
              handleClick={handleBreadcrumpDataClicked}
              maxBreadcrumpsLength={10}
            />
          }
          breadcrumpList={breadcrumpList}
          handleBoxClick={(data) => handleRowClick(data)}
          handlePaste={handlePaste}
          setDataMove={setDataMove}
          setShowPasteButton={setShowPasteButton}
          showPasteButton={showPasteButton}
          dataMove={dataMove}
          data={showSharedFileFolder ? sharedFileFolderData : mySpaceDocumentList || []}
          documentContextMenu={DOCUEMNT_CONTEXT_MENU}
          outDocumentContextMenu={OUTER_DOCUEMNT_CONTEXT_MENU}
          actionField={
            <Fragment>
              <button
                onClick={() => {
                  setShowSharedFileFolder(!showSharedFileFolder);
                  navigate(showSharedFileFolder ? "/my_space/folders" : "/my_space/shared/folders");
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className="group flex items-center gap-2 text-primary-80 hover:text-primary px-2 py-1 border-[1px] border-[#D9D9D9] rounded-[5px] whitespace-nowrap text-sm"
              >
                <LoginIcon isActive={isHovered} />
                {showSharedFileFolder ? "My Space" : "Shared With Me"}
              </button>

              {/* <NewToggleSwitch onToggle={handleToggle} toggleState={isListView} className={"w-30 h-8"} /> */}
              {/* {!showSharedFileFolder && ( */}
              <ToolTipComponent text="Add">
                <button type="button" className="text-primary-70 hover:text-primary-80">
                  <MenuOptionsDropdown
                    buttonIcon={<PlusIcon isActive={createMenuModal} />}
                    menuItems={[
                      {
                        label: "Add Folder",
                        icon: <NewFolderIcon className=" w-4 h-4 mr-2" />,
                        onClick: () => {
                          handleNewFolderOptionClick();
                        },
                      },
                      {
                        label: "Upload File",
                        icon: <NewFilesUpload className="w-4 h-4 mr-2" />,
                        onClick: () => {
                          handleNewFileOptionClick();
                        },
                      },
                      {
                        label: "Create List",
                        icon: <CreateList className="w-4 h-4 mr-2" />,
                        onClick: () => {
                          handleCreateListClick();
                        },
                      },
                    ]}
                    onOpen={() => console.log("Dropdown Opened")}
                    onClose={() => console.log("Dropdown Closed")}
                  />
                </button>
              </ToolTipComponent>
              {/* )} */}

              <Menu anchorEl={createMenuModal} open={Boolean(createMenuModal)} onClose={handleMenuClose} sx={{ mr: 1 }}>
                <MenuItem onClick={openFolderDialog} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
                  <ListItemIcon>
                    <FolderIcon fontSize="small" className="text-ffe851" />
                  </ListItemIcon>
                  Add Folder
                </MenuItem>
                <MenuItem onClick={openPopup} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
                  <ListItemIcon>
                    <AttachmentIcon fontSize="small" className="text-4285F4" />
                  </ListItemIcon>
                  Attach File
                </MenuItem>
              </Menu>
            </Fragment>
          }
          noDataFound={NO_DATA_FOUND_TABLE_JSX}
        />
      )}
      {/*------------ SHOW THE CREATE LIST MODAL -------------*/}
      {isShowCreateList && (
        <CreateListDrawer
          open={isShowCreateList}
          onClose={() => {
            setIsShowCreateList(false);
          }}
          handleCreateList={handleCreateList}
          onSuccess={() => {
            handleGetContainerList({ containerId: breadcrumpList[breadcrumpList.length - 1]?.id || null });
            setIsShowCreateList(false);
          }}
          customerId={customerId}
          folderId={breadcrumpList[breadcrumpList.length - 1]?.id}
          setShowCsvUploadPreview={setShowCsvUploadPreview}
          csvFileData={csvFileData}
          setCsvFileData={setCsvFileData}
        />
      )}
      {/*------------ SHOW THE FILE UPLOAD MODAL -------------*/}
      {showFileUploadModal && (
        <div className="fixed inset-0 flex items-center justify-center z-[102]">
          <FileUploadModal
            open={showFileUploadModal}
            onClose={closePopup}
            currentFolderId={breadcrumpList[breadcrumpList.length - 1]?.id}
            onSuccess={(currentFolderId) => handleGetContainerList({ containerId: currentFolderId })}
          />
        </div>
      )}
      {/*-------------- SHOW SHARE FOLDER/FILE MODAL --------------*/}
      {showShareDialog && (
        <div className="fixed inset-0 flex items-center justify-center z-[102]">
          <ShareFileModal
            open={showShareDialog}
            close={() => setShareDialog(null)}
            sharedAssetInfo={showShareDialog || null}
          />
        </div>
      )}
      {isAssetShareDrawerOpen && (
        <SharedPerson
          open={isAssetShareDrawerOpen}
          onClose={() => setIsAssetShareDrawerOpen(null)}
          sharedAssetInfo={isAssetShareDrawerOpen}
        />
      )}
      {/*------------ SHOW AI PREVIEW MODAL OPTION ------------*/}
      {showAIPreviewModal && <OverviewDialog open={showAIPreviewModal} close={() => setShowAIPreviewModal(false)} />}
      {/*------------ SHOW REQUEST ACCESS MODAL (NOT FINALISED THE FUNCTIONALITY) -------------*/}
      {requestDocumentAccessModal && (
        <RequestAccessDialog
          open={requestDocumentAccessModal}
          onClose={() => setRequestDocumentAccessModal(false)}
          onClose2={() => {
            setRequestDocumentAccessModal(false);
            setOpenApproverDialog(true);
          }}
        />
      )}
      {/*------------ SHOW ACCEPT ACCESS MODAL, DEPEND ON REQUEST MODAL (NOT FINALISED THE FUNCTIONALITY) -------------*/}
      {openApproverDialog && (
        <ApproverDialogue
          open={openApproverDialog}
          close={() => {
            setOpenApproverDialog(false);
          }}
          onSubmit={() => {
            window.alert("API Integration Pending");
            setOpenApproverDialog(false);
          }}
        />
      )}
      {/*------------- SHOW MODAL TO MOVE DOCUMENT USING MODAL, ONLY FOR LIST VIEW --------------*/}
      {openMoveDialog && isListView && (
        <MoveDocumentModal
          open={openMoveDialog}
          close={() => setOpenMoveDialog(false)}
          breadcrumpList={breadcrumpList}
          setBreadcrumpList={setBreadcrumpList}
          handleRowClick={handleRowClick}
          headerData={HEADER_DEFINITION}
          handleBreadcrumpDataClicked={handleBreadcrumpDataClicked}
          documentData={mySpaceDocumentList?.filter((data) => data.type === "folder" && data?.id !== dataMove?.id)}
          dataMove={dataMove}
          handleDirectory={handleDirectory}
          handleDirectoryBack={handleDirectoryBack}
          handleOpenFolder={handleOpenFolder}
          openFolderDialog={openFolderDialog}
          handlePaste={handlePaste}
        />
      )}
      {/*------------ SHOW MODAL TO ADD FOLDER ------------*/}
      {showAddFolderModal && (
        <AddFolderModal
          showAddFolderModal={showAddFolderModal}
          handleDialogClose={handleDialogClose}
          handleFolderNameChange={handleFolderNameChange}
          handleColorSelect={handleColorSelect}
          folderName={folderName}
          folderColor={folderColor}
          colorOptions={colorOptions}
          handleSubmit={handleSubmit}
        />
      )}
      {/*---------- MODAL TO SHOW ACTIVITY ------------*/}
      {openActivityDialog && (
        <CustomerEditTaskActivity
          open={openActivityDialog}
          onClose={() => {
            setOpenActivityDialog(false);
          }}
          token={getUserToken()}
          activityid={activityId}
          type={"Document"}
        ></CustomerEditTaskActivity>
      )}
      {isRenameFolderFileModalOpen && (
        <RenameFolderFileModal
          open={isRenameFolderFileModalOpen}
          onClose={() => setIsRenameFolderFileModalOpen(false)}
          initialName={isRenameFolderFileModalOpen?.display_name}
          onSuccess={(currentFolderId) => handleGetContainerList({ containerId: currentFolderId })}
          headerText={isRenameFolderFileModalOpen?.type === "folder" ? "Folder" : "File"}
          // folderId={folderId}
          // onSuccess={handleGetContainerList}
        />
      )}
      {isDeleteFolderFileModalOpen && (
        <ConfirmationDialog
          open={isDeleteFolderFileModalOpen}
          onConfirm={() => {
            handleDeleteFileFolder();
          }}
          onClose={() => setIsDeleteFolderFileModalOpen(false)}
          title="Delete"
          message={`Are you sure you want to delete ${isDeleteFolderFileModalOpen?.display_name}?`}
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
          iconVariant={"delete"}
        />
      )}

      {isMySpacePinnedDrawerOpen && (
        <MySpacePinnedDrawer onClose={() => setIsMySpacePinnedDrawerOpen(false)} open={isMySpacePinnedDrawerOpen} />
      )}
      {/*------------ PREVIEW MODAL FOR PDF FILES ------------*/}
      {/* {showFilePreviewDialog && (
        <PdfPreviewModal
          open={showFilePreviewDialog}
          onClose={() => setShowFilePreviewDialog(false)}
          fileUrl={selectedRowData?.access_sas_link}
          filename={selectedRowData?.display_name}
        />
      )} */}
    </div>
  );
};

export default MySpaceDocument;
